import { z } from "zod";
import { translateApp } from "@/i18n";
import { defaultPublicBrandProfile } from "@/shared/branding/public-brand";
export const publicBrandProfileSchema = z
    .object({
    name: z.string().default(defaultPublicBrandProfile.name),
    logoUrl: z.string().nullable().default(null),
    fontFamily: z.string().default(defaultPublicBrandProfile.fontFamily),
    colors: z
        .object({
        primary: z.string().default(defaultPublicBrandProfile.colors.primary),
        text: z.string().default(defaultPublicBrandProfile.colors.text),
        accent: z.string().default(defaultPublicBrandProfile.colors.accent),
        success: z.string().default(defaultPublicBrandProfile.colors.success),
        background: z
            .string()
            .default(defaultPublicBrandProfile.colors.background),
    })
        .default(defaultPublicBrandProfile.colors),
    support: z
        .object({
        name: z.string().nullable().default(null),
        email: z.string().nullable().default(null),
    })
        .default(defaultPublicBrandProfile.support),
})
    .strip();
export const ReviewInvitationStatusSchema = z.enum([
    "active",
    "already_submitted",
    "expired",
    "revoked",
    "consumed",
    "disabled",
]);
export const ReviewInvitationPageStateSchema = z.enum([
    "loading",
    "eligible",
    "already_submitted",
    "invalid",
    "revoked",
    "expired",
    "consumed",
    "disabled",
    "success",
]);
export const ReviewLanguageSourceSchema = z.enum([
    "customer_preference",
    "country_hint",
    "organization_default",
    "system_default",
]);
export const reviewInvitationContextSchema = z
    .object({
    status: ReviewInvitationStatusSchema,
    service_name: z.string().nullable().optional(),
    service_date: z.string().nullable().optional(),
    locale: z.string().nullable().optional(),
    effective_locale: z.string().nullable().optional(),
    language_source: ReviewLanguageSourceSchema.nullable().optional(),
    brand: publicBrandProfileSchema.nullable().optional(),
})
    .strip();
export const submitReviewSchema = z.object({
    rating: z
        .number({
        required_error: translateApp("reviews.validation.rating_required"),
    })
        .min(1, translateApp("reviews.validation.rating_required"))
        .max(5),
    comment: z
        .string()
        .max(1000, translateApp("reviews.validation.comment_max"))
        .optional()
        .default(""),
});
export const reviewReplySchema = z
    .object({
    id: z.string(),
    body: z.string(),
    status: z.string().default("published"),
    organization_id: z.number().optional(),
    author_user_id: z.string().optional(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
    hidden_at: z.string().nullable().optional(),
    hide_reason: z.string().nullable().optional(),
})
    .strip();
export const providerReviewSchema = z
    .object({
    id: z.number().optional(),
    review_id: z.number().optional(),
    itinerary_id: z.number().optional(),
    service_id: z.number().optional(),
    service_name: z.string(),
    provider_name: z.string().optional(),
    rating: z.number().min(1).max(5),
    comment: z.string().nullable().optional(),
    date: z.string(),
    moderation_status: z.string().default("published"),
    provider_reply: reviewReplySchema.nullable().optional().default(null),
})
    .strip();
export const providerReviewsApiResponseSchema = z.object({
    stats: z.object({
        totalReviews: z.number(),
        averageRating: z.number().nullable(),
        thisMonth: z.number(),
    }),
    reviews: z.array(providerReviewSchema),
});
export const platformReviewsApiResponseSchema = z.object({
    items: z.array(providerReviewSchema),
    total: z.number().default(0),
});
